import { ReactNode, useEffect } from 'react';
import * as C from './styles';
import { TbX } from 'react-icons/tb';

interface IDataModal {
  id?: number;
  titleHeader: string;
  title?: string;
  desc?: string;
  src?: string;
  value?: number;
  children?: ReactNode;
  elementButton?: ReactNode;
  mxheight?: string;
  height?: string;

  onClose: () => void;
}

export const InitModal = ({
  titleHeader,
  title,
  desc,
  src,
  children,
  mxheight,
  onClose,
  height,
}: IDataModal) => {
  // Bloqueia scroll do body quando modal está aberto
  useEffect(() => {
    if (typeof window !== 'undefined' && window.document && window.document.body) {
      window.document.body.style.overflow = 'hidden';
    }

    return () => {
      if (typeof window !== 'undefined' && window.document && window.document.body) {
        window.document.body.style.overflow = 'unset';
      }
    };
  }, []);

  return (
    <C.Container>
      <C.Content mxheight={mxheight} height={height}>
        <C.Header>
          <h4>{titleHeader}</h4>

          <span onClick={onClose}>
            <TbX />
          </span>
        </C.Header>
        <C.BoxInfo>
          <C.Img src={src}></C.Img>
          <C.InfoProd>
            <h4>{title}</h4>
            <div>{desc}</div>
            {children}
          </C.InfoProd>
          {/* <C.Footer>
                    </C.Footer> */}
        </C.BoxInfo>
      </C.Content>
    </C.Container>
  );
};
